import { Component, Input } from "@angular/core";
import ReopenHistoryTableItem from "@models/reopenHistoryTableItem";

@Component({
  selector: "reopenHistoryTable",
  templateUrl: "./reopenHistoryTable.component.html",
  styleUrls: ["./reopenHistoryTable.component.scss"],
  standalone: false
})
export class ReopenHistoryTableComponent {
  @Input() data: ReopenHistoryTableItem[] = [];
}
